/**
 * Utilidades para prefetch de recursos críticos
 * ✅ FASE 4: Advanced optimization para mejor UX
 */

/**
 * Prefetch de una imagen para cargarla en background
 */
export function prefetchImage(src) {
  if (!src || typeof window === 'undefined') return;
  
  const img = new Image();
  img.src = src;
  
  // Opcional: agregar a cache del navegador
  img.onload = () => {
    console.debug(`Prefetched image: ${src}`);
  };
  
  img.onerror = () => {
    console.warn(`Failed to prefetch image: ${src}`);
  };
}

/**
 * Prefetch de múltiples imágenes
 */
export function prefetchImages(srcArray) {
  if (!Array.isArray(srcArray)) return;
  
  srcArray.forEach(src => {
    if (src) prefetchImage(src);
  });
}

/**
 * Prefetch de una página/ruta para navegación instantánea
 */
export function prefetchRoute(path) {
  if (!path || typeof window === 'undefined') return;
  
  // Crear link invisible para prefetch
  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.href = path;
  
  document.head.appendChild(link);
  
  // Limpiar después de un tiempo
  setTimeout(() => {
    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
  }, 5000);
}

/**
 * Prefetch inteligente basado en hover
 */
export function setupHoverPrefetch() {
  if (typeof window === 'undefined') return;
  
  let prefetchTimeout;
  
  document.addEventListener('mouseover', (e) => {
    const link = e.target.closest('a[href]');
    if (!link) return;
    
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
    
    // Prefetch después de 100ms de hover (evita prefetch accidental)
    prefetchTimeout = setTimeout(() => {
      prefetchRoute(href);
    }, 100);
  });
  
  document.addEventListener('mouseout', () => {
    if (prefetchTimeout) {
      clearTimeout(prefetchTimeout);
    }
  });
}

/**
 * Prefetch de datos críticos usando fetch
 */
export async function prefetchData(url, options = {}) {
  if (!url || typeof window === 'undefined') return;
  
  try {
    const response = await fetch(url, {
      ...options,
      priority: 'low', // No interferir con requests críticos
    });
    
    if (response.ok) {
      // Los datos quedan en cache del navegador
      console.debug(`Prefetched data: ${url}`);
    }
  } catch (error) {
    console.warn(`Failed to prefetch data: ${url}`, error);
  }
}